/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import $ from 'jquery';
import './confirmation_window.scss';

export default (selector = '.js-trigger-confirmation') => {
  $(selector + ':not(.js-done)')
    .addClass('js-done')
    .on('click', ev => {
      ev.preventDefault();
      const $el = $(ev.currentTarget);
      const {confirmTarget, cancelTarget} = $el.data();
      const $confWin = $('#confirmation-window');
      const winContent = $el.siblings('.confirmation-window-content').html();

      if (!confirmTarget || !$confWin || !winContent) {
        return;
      }

      $confWin.find('.cancel').one('click', ev => {
        ev.preventDefault();
        if (cancelTarget) {
          $(ev.currentTarget).attr('href', cancelTarget);
        } else {
          $confWin.removeClass('is-open');
        }
      }).end()
        .attr('action', confirmTarget)
        .find('.window-content').html(winContent).end()
        .addClass('is-open');
    });
};
